import { render } from "./CellAthPrcd.vue?vue&type=template&id=c916fc52"
import script from "./CellAthPrcd.vue?vue&type=script&lang=js"
export * from "./CellAthPrcd.vue?vue&type=script&lang=js"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__